import { useQuery, QueryStatus, keepPreviousData } from '@tanstack/react-query';
import useReduxStateMarket, {
  MarketPageType,
} from '@/pages/Market/hooks/useReduxStateMarkets';
import useIndustryGetter from '@/pages/Market/hooks/useIndustryGetter';
import {
  getDefault,
  getMarketPerformanceKey,
  PeriodType,
  queryFn,
  Response,
} from '@/pages/Market/query/fetchMarketPerformance';

export default function (period: PeriodType): {
  data: Response;
  status: QueryStatus;
} {
  const { market, marketPageType } = useReduxStateMarket();
  const [{ id }, enabled] = useIndustryGetter();
  const { data = getDefault(), status } = useQuery({
    queryKey: getMarketPerformanceKey(market, id, period),
    queryFn,
    staleTime: Infinity,
    enabled: marketPageType === MarketPageType.MARKET ? true : enabled,
    refetchOnMount: false,
    placeholderData: keepPreviousData,
  });

  return { status, data };
}
